import { ChangeDetectionStrategy, Component, inject, input, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RegionService } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-region-popover',
  templateUrl: './region-popover.component.html',
  styleUrls: ['./region-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionPopoverComponent {
  readonly router = inject(Router);
  readonly regionService = inject(RegionService);

  readonly regionId = input<string>();

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  readonly region = asyncComputed(() => {
    const regionId = this.regionId();
    if (!regionId) {
      return undefined;
    }
    return this.regionService.findById(regionId);
  },undefined, this.loading);

  navigateToDetail() {
    this.router.navigate(['region', this.region()?.id]);
  }
}
